import { p as palette } from '../base/color-DMp1DFwP.js';
import { a as spacingValues, s as spacing } from '../base/spacing-zNVNrnl_.js';
import { t as typography } from '../base/typography-Bqsizo4g.js';

const treeViewStyles = {
  indentValue: spacingValues.medium,
  discloseIconColor: typography.color.tertiary,
  discloseIconSize: spacing.mini,
  discloseButtonSize: spacing.medium,
  discloseButtonWrapperSize: spacing.xlarge,
  nodeContentPadding: spacing.micro,
  nodeSeparator: `1px solid ${palette.mercury}`,
  nodeActiveColor: palette.haze
};

export { treeViewStyles as t };
//# sourceMappingURL=treeView-DXFpY_pF.js.map
